/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

const room_data_home = async (params: any, store: any) => {
  const {h_web_room_id} = store.getState().env.deviceinfo
  const resp = await http.post(
    '/live/room/get_room_dashboard_data',
    {
      room_id: h_web_room_id,
      ...params,
    },
    {store, xcErrorToast: true}
  )
  return resp.data.data
}
export const room_data_board_daily = createAsyncThunk(
  'RoomDataBoard/gala_rank_daily',
  (params: any, store: any) => room_data_home({type: 1, ...params}, store)
)
export const room_data_board_week = createAsyncThunk(
  'RoomDataBoard/gala_rank_week',
  (params: any, store: any) => room_data_home({type: 2, ...params}, store)
)

export const get_room_role = createAsyncThunk(
  'RoomDataBoard/get_room_role',
  async (params: any, store: any) => {
    const {h_web_room_id, h_m} = store.getState().env.deviceinfo
    const resp = await http.post(
      '/live/room/get_room_role',
      {
        room_id: h_web_room_id,
        mid: h_m,
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return (resp?.data?.data?.role || 0) - 1
  }
)
const initialState: {
  daily: any
  week: any
  base: {
    role: number
  }
} = {
  daily: {},
  week: {},
  base: {
    role: -1,
  },
}

export const RoomDataBoardSlice = createSlice({
  name: 'RoomDataBoard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(room_data_board_daily.fulfilled, (state, action) => {
      Object.assign(state.daily, action.payload)
    })
    builder.addCase(room_data_board_week.fulfilled, (state, action) => {
      Object.assign(state.week, action.payload)
    })
    builder.addCase(get_room_role.fulfilled, (state, action) => {
      Object.assign(state.base, {role: action.payload})
    })
  },
})

export const useRoomDataBoard = () =>
  useSelector((store) => store.RoomDataBoard)

export default RoomDataBoardSlice.reducer
export const RoomDataBoardActions = RoomDataBoardSlice.actions
